import hljs from 'highlight.js'
hljs.initHighlightingOnLoad()
